import { FormField } from "../../components/FormElements/FormFieldsRenderer";

const editPatientOwnProfile = (t, requiredFields, regionProps, pharmacyProps) => {
  const patientFormDefinitions = [
    {
      key: 'firstName'
    },
    {
      key: 'lastName'
    },
    {
      key: 'idNumber'
    },
    {
      key: 'address'
    }
  ];

  const formFields: FormField[] = patientFormDefinitions.map(field => {
    const { key } = field;

    return {
      label: t(`common.registrationForm.${key}`),
      prefix: 'editPatientProfile',
      isRequired: requiredFields[key],
      fieldType: 'Text',
      isFullWidth: true,
      subType: 'text',
      name: key
    };
  });

  formFields.push(
    {
      label: t(`regionSelector.county`),
      prefix: 'editPatientProfile',
      isRequired: true,
      regionProps: regionProps,
      name: 'region',
      fieldType: 'Region'
    },
    {
      label: t(`common.registrationForm.phone`),
      prefix: 'editPatientProfile',
      isRequired: requiredFields.phone,
      fieldType: 'Text',
      isFullWidth: true,
      subType: 'text',
      name: 'phone'
    },
    {
      label: t(`common.registrationForm.preferredPharmacy`),
      prefix: 'editPatientProfile',
      isRequired: requiredFields.pharmacy,
      fieldType: 'Pharmacy',
      isFullWidth: true,
      name: 'pharmacyId',
      pharmacyProps: pharmacyProps
    }
  );

  return formFields;
}

export default editPatientOwnProfile;
